import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Chip,
  TextField,
  Rating,
} from '@mui/material';

const TAGS = [
  { value: 'too_difficult', label: 'Too Difficult' },
  { value: 'too_easy', label: 'Too Easy' },
  { value: 'wrong_topic', label: 'Wrong Topic Focus' },
  { value: 'not_curriculum_aligned', label: 'Not Curriculum Aligned' },
  { value: 'too_similar', label: 'Questions Too Similar' },
  { value: 'vocab_too_complex', label: 'Vocabulary Too Complex' },
];

export default function FeedbackModal({ isOpen, onSubmit, onSkip }) {
  const [rating, setRating] = useState(null);
  const [selectedTags, setSelectedTags] = useState([]);
  const [note, setNote] = useState('');
  const showNoteBox = rating !== null && rating <= 3;

  const toggleTag = (tag) => {
    setSelectedTags((prev) =>
      prev.includes(tag)
        ? prev.filter((item) => item !== tag)
        : [...prev, tag]
    );
  };

  const handleSubmit = () => {
    onSubmit?.({
      rating,
      tags: selectedTags,
      teacher_note: note.trim().slice(0, 500),
    });
    setRating(null);
    setSelectedTags([]);
    setNote('');
  };

  const handleSkip = () => {
    onSkip?.();
    setRating(null);
    setSelectedTags([]);
    setNote('');
  };

  return (
    <Dialog open={Boolean(isOpen)} onClose={handleSkip} maxWidth="sm" fullWidth>
      <DialogTitle>How were these questions?</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
          <Rating
            value={rating}
            onChange={(event, value) => setRating(value)}
            size="large"
          />
          <Typography variant="body2" color="text.secondary">
            {rating ? `${rating}/5` : 'Select a rating'}
          </Typography>
        </Box>

        {rating !== null && (
          <Box sx={{ mb: 2 }}>
            <Typography variant="body2" sx={{ mb: 1 }}>
              What needs improvement? <Typography component="span" variant="caption" color="text.secondary">(optional)</Typography>
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
              {TAGS.map((tag) => (
                <Chip
                  key={tag.value}
                  label={tag.label}
                  color={selectedTags.includes(tag.value) ? 'primary' : 'default'}
                  variant={selectedTags.includes(tag.value) ? 'filled' : 'outlined'}
                  onClick={() => toggleTag(tag.value)}
                />
              ))}
            </Box>
          </Box>
        )}

        {showNoteBox && (
          <TextField
            label="Anything specific? (optional)"
            value={note}
            onChange={(event) => setNote(event.target.value.slice(0, 500))}
            multiline
            minRows={3}
            fullWidth
            helperText={`${note.length}/500`}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleSkip}>Skip</Button>
        <Button variant="contained" onClick={handleSubmit} disabled={rating === null}>
          Submit Feedback
        </Button>
      </DialogActions>
    </Dialog>
  );
}

